import React from "react";

const RevisionHistorySection = (props) => {
  return (
    <div className="revision-history-container">
      <div className="title">規約等改訂履歴</div>
      <div className="text">
        2019年4月1日 社名変更に伴い改定
        <br />
        2018年6月7日 制定
      </div>
    </div>
  );
};

export default RevisionHistorySection;
